import { render, staticRenderFns } from "./HomeFeedDoubleMenuChild.vue?vue&type=template&id=68aaf474&scoped=true"
import script from "./HomeFeedDoubleMenuChild.vue?vue&type=script&lang=js"
export * from "./HomeFeedDoubleMenuChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aaf474",
  null
  
)

export default component.exports